<template>
  <div class="checkin-step3">
    <div class="flex-hb-vt">
      <div class="module-passenger">
        <h4>乘机人信息</h4>
        <div >
          <div class="mt50" v-if="passengerLoading">
            <a-spin tip="正在加载乘机人信息..." />
          </div>
          <passengerInfo
            v-else
            :passengerData="passengerData"
            :mutiPassengerData="mutiPassengerData"
            :passengerLoading="passengerLoading"
            @select="onSelectPassenger"
            @update="onUpdatePassenger"
          >
          </passengerInfo>
        </div>
      </div>
      <div class="module-seat">
        <h4>座位信息</h4>
        <div class="mt50" v-if="seatLoading">
          <a-spin tip="正在加载座位信息..." />
        </div>
        <div
          v-else
          class="seat-bg clearfix"
          v-bind:class="[airplaneData.airplaneType=='330'?'airplane-type-330':'airplane-type-normal']"
        >
          <div class="seat-head">
            <p>{{airplaneData.airplaneType}}-{{airplaneData.airplaneClass}}</p>
          </div>
          <div class="seat-body">
            <div class="seat-body-in clearfix">
              <seat-map :seatData="seatData" @selectSeat="updateSeatItem"></seat-map>
            </div>
          </div>
          <div class="seat-tail"></div>
          <span class="wing wing-top"></span>
          <span class="wing wing-bottom"></span>
        </div>
        <div class="seat-desc">
          <ul class="seat-desc-list clearfix">
            <li>
              <div class="seat-desc-item seat3">
                <p class="seat-title">当前可选座位</p>
                <p>可免费选择座位值机</p>
              </div>
            </li>
            <li>
              <div class="seat-desc-item seat4">
                <p class="seat-title">当前座位已被选择</p>
                <p>座位已被选，无法接受值机</p>
              </div>
            </li>
            <li>
              <div class="seat-desc-item seat5">
                <p class="seat-title">不能值机座位</p>
                <p>飞机配载限制，无法接受值机</p>
              </div>
            </li>
            <li>
              <div class="seat-desc-item seat6">
                <p class="seat-title">您当前选中的座位</p>
                <p>旅客当前已选中的座位</p>
              </div>
            </li>
            <li>
              <div class="seat-desc-item seat7">
                <p class="seat-title">同行人员已选座位</p>
                <p>同行程旅客当前已选中的座位</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="module-action">
      <div class="checkin-operation">
        <l8-imgcaptcha ref="verify" v-model="captcha" :size="'large'"></l8-imgcaptcha>
        <a-button type="primary" class="submit-btn" size="large" @click="handleCheckInReady" :loading="isSubmitLoading">确认办理</a-button>
      </div>
    </div>
  </div>
</template>
<script>
import { checkinData, retrieveSeat, multiCheckin, checkPassengerTypeRatio } from '@/apis/checkin'
import { cloneDeep, differenceWith, isEqual } from 'lodash'
import moment from 'moment'
import Observer from '@/assets/js/observer'
import passengerInfo from './passengerInfo'
import seatMap from './seatMap'

const certTypeMap = {
  'NI': '身份证',
  'PP': '护照',
  'TN': '电子客票'
}
const emptySeatClass = 'icon2 icon2-seats-ordinary'
export default {
  props: {
    stepData: { type: Object },
    pageData: { type: Object }
  },
  data () {
    return {
      airline: window.__MICRO_ROOT__?.airline,
      certTypeMap,
      captcha: '',
      airplaneData: {},
      seatData: [],
      seatNumber: '',
      passengerData: {},
      passengerLoading: true,
      seatLoading: true,
      currentIndex: 0,
      originData: {},
      mutiPassengerData: [],
      isSubmitLoading: false
    }
  },
  created () {
    this.getSeatData()
    window.__MICRO_ROOT__?.api?.track?.('checkin_seatmap')
  },
  methods: {
    async getPassengerData () {
      const flight = this.stepData
      const data = {
        airline: flight.airline,
        arrCode: flight.arrCode,
        cabin: flight.cabin,
        certNo: flight.certNo,
        depCode: flight.depCode,
        depTime: flight.depTime,
        flightNo: flight.flightNo,
        ticketNo: flight.ticketNo,
        certType: 'TN' // 写死证件类型为票号
      }

      try {
        const result = await checkinData(data)
        this.passengerLoading = false
        if (result.depTime) {
          let timeFormat = moment(result.depTime).format()
          result.depTimeFormat = timeFormat.split('T')[1].slice(0, 5)
          result.depDateFormat = timeFormat.split('T')[0]
        } else {
          result.depTimeFormat = ''
          result.depDateFormat = ''
        }
        if (result.arrTime) {
          result.arrTimeFormat = moment(result.arrTime).format().split('T')[1].slice(0, 5)
        } else {
          result.arrTimeFormat = ''
        }

        // NOTE: 进入值机选座流程，只有'可用'这种状态
        result.statusText = '可用'

        this.passengerData = result
        this.passengerData.certType = this.certTypeMap[this.pageData.certType]
        this.passengerData.certNo = this.pageData.certNo
        // NOTE: 新增入参 - 多人值机需要
        this.passengerData.tourIndex = this.pageData.tourIndex
        this.passengerData.certTypeOrigin = this.pageData.certType
      } catch (err) {
        this.passengerLoading = false
        this.$message.error(err.message)
        this.$emit('callback', 1)
      }
    },
    async getSeatData () {
      try {
        const data = {
          ...this.stepData
        }
        const result = await retrieveSeat(data)
        this.seatLoading = false
        this.airplaneData = {
          airplaneType: result.airplaneType,
          airplaneClass: result.airplaneClass
        }
        this.seatData = result.seats
        this.getPassengerData()
      } catch (err) {
        this.$message.error(err.message)
        this.$emit('callback', 1)
      }
    },
    async handleCheckInReady () {
      const { originData = {}, mutiPassengerData = [] } = this
      // NOTE: 值机校验 - 防止未选座位提交
      const seatEmptyFlag = mutiPassengerData?.findIndex(item => { return !item.seatNumber })
      if (seatEmptyFlag >= 0) {
        this.$message.error('请选择座位！')
        return
      }
      if (!this.captcha) {
        this.$message.error('请输入图片验证码！')
        return
      }
      const params = cloneDeep(originData)
      const luggageData = [{ baggageWeight: originData.psrInput?.baggageWeight, passengerName: originData.psrInput?.passengerName }]
      const mainSeatNumber = mutiPassengerData.find(item => { return item.ticketID === originData.psrInput?.tktNumber })?.seatNumber
      params.psrInput.seatNumber = mainSeatNumber
      for (let index = 0; index < originData.partners?.length; index++) {
        const partner = originData.partners[index]
        const partnerSeatNumber = mutiPassengerData.find(item => { return item.ticketID === partner.ticketID })?.seatNumber
        params.partners[index].seatNumber = partnerSeatNumber
        luggageData.push({ baggageWeight: partner.baggageWeight, passengerName: partner.passengerName })
      }

      const observer = new Observer()
      // NOTE: 8L 值机增加行李判断
      // 20231102 下线
      // if (airline === '8L' && luggageData.length > 0) {
      //   let dom = ''
      //   for (let index = 0; index < luggageData.length; index++) {
      //     const item = luggageData[index]
      //     const baggageWeight = item.baggageWeight
      //     dom += `<p>旅客${item.passengerName}，免费托运行李${baggageWeight.follow}KG，已购买付费行李${baggageWeight.alone}KG；</p>`
      //   }
      //   dom += '<p>如需购买更多行李，请点击“去购买”，享受最高优惠！</p>'
      //   observer.add(() => {
      //     return new Promise((resolve, reject) => {
      //       this.$confirm({
      //         title: '温馨提示',
      //         content: (h) => h('div', {
      //           domProps: {
      //             innerHTML: dom
      //           }
      //         }),
      //         okText: '去购买',
      //         cancelText: '暂不购买',
      //         onOk: () => {
      //           this.$router.push({ path: '/extraalone/validate' })
      //         },
      //         onCancel: () => {
      //           resolve()
      //         }
      //       })
      //     })
      //   })
      // }

      observer.complete = () => {
        this.handleCheckInFinally(params)
      }

      observer.start()
    },
    async handleCheckInFinally (params) {
      const { originData = {} } = this
      this.isSubmitLoading = true
      try {
        // 校验人数
        await checkPassengerTypeRatio({ checkinId: originData.checkinId })
        const result = await multiCheckin(params)
        this.$emit('callback', 4, result, this.passengerData)
        this.isSubmitLoading = false
        window.__MICRO_ROOT__?.api?.track?.('checkin_succeed')
      } catch (err) {
        this.$refs.verify.refresh()
        this.$message.error(err.message)
        this.isSubmitLoading = false
        window.__MICRO_ROOT__?.api?.track?.('checkin_failed')
      }
    },
    // 选座更新座位图
    updateSeatItem (seatNumber) {
      const { mutiPassengerData = [], currentIndex, seatData = [] } = this
      this.$set(mutiPassengerData?.[currentIndex], 'seatNumber', seatNumber)
      for (let index = 0; index < seatData.length; index++) {
        const seat = seatData[index] ?? {}
        if (seat.styleClass?.indexOf('seat-checked-fellow') < 0 && seat.styleClass?.indexOf('seat-checked') >= 0 && seat.seatNumber !== seatNumber) {
          this.$set(this.seatData?.[index], 'styleClass', emptySeatClass)
        }
      }
    },
    // 删除同行人，恢复座位图
    resetSeatItem (seatNumber) {
      const { seatData = [] } = this
      const seatIndex = seatData.findIndex(item => { return item.seatNumber === seatNumber })
      if (seatIndex >= 0) {
        this.$set(this.seatData?.[seatIndex], 'styleClass', emptySeatClass)
      }
    },
    onSelectPassenger (currentIndex) {
      this.currentIndex = currentIndex
      const { seatData = [], mutiPassengerData = [] } = this
      for (let index = 0; index < mutiPassengerData.length; index++) {
        const passengerData = mutiPassengerData[index]
        if (!passengerData.seatNumber) return
        const seatIndex = seatData.findIndex(item => { return item.seatNumber === passengerData.seatNumber })
        this.$set(this.seatData?.[seatIndex], 'styleClass', currentIndex !== index ? `${emptySeatClass} seat-checked-fellow` : `${emptySeatClass} seat-checked`)
      }
    },
    onUpdatePassenger (newValues = [], result = {}) {
      this.originData = result
      const { mutiPassengerData = [] } = this
      const oldValues = mutiPassengerData.map(item => { return { passengerName: item.passengerName, ticketID: item.ticketID } })
      const isAdd = newValues.length > oldValues.length
      const diffValues = isAdd ? differenceWith(newValues, oldValues, isEqual) : differenceWith(oldValues, newValues, isEqual)
      if (!isAdd) {
        // 删除同行人
        const index = oldValues.findIndex(item => { return item.ticketID === diffValues[0].ticketID })
        // 恢复同行人座位
        this.resetSeatItem(this.mutiPassengerData[index].seatNumber)
        this.mutiPassengerData.splice(index, 1)
      } else {
        // 添加同行人
        this.mutiPassengerData = mutiPassengerData.concat(diffValues)
      }
    }
  },
  components: {
    passengerInfo,
    seatMap
  }
}
</script>

<style lang="less" scoped>
.checkin-step3 {
  .module-passenger {
    width: 15%;
  }
  .module-seat {
    width: 82%;
  }
  h4 {
    margin-bottom: 20px;
    font-size: 24px;
    line-height: 32px;
    font-weight: bold;
  }
  .mt50 {
    margin-top: 50px;
    text-align: center;
  }
  .flight-seat {
    margin-top: 50px;
  }
  .seat-bg {
    position: relative;
    display: flex;
    justify-content: center;
  }
  .seat-head {
    position: relative;
    p {
      position: absolute;
      transform: rotate(-90deg);
      text-align: right;
      margin-top: 80px;
      right: 0;
      font-size: 14px;
    }
  }
  .seat-body {
    float: left;
    min-width: 230px;
    max-width: 800px;
    padding: 5px 25px;
    border-top: 1px solid #808080;
    border-bottom: 1px solid #808080;
    position: relative;
    flex: 1 0 auto;
  }
  .wing {
    display: block;
    position: absolute;
    width: 125px;
    height: 11px;
    left: 40%;
  }
  .wing-top {
    background-image: url(../img/wing_top.png);
    top: -10px;
  }
  .wing-bottom {
    background-image: url(../img/wing_bottom.png);
    bottom: -10px;
  }
  .airplane-type-normal {
    .seat-bg {
      margin-top: 55px;
    }
    .seat-head {
      float: left;
      width: 164px;
      height: 178px;
      background-image: url(../img/head.png);
      background-repeat: no-repeat;
    }
    .seat-tail {
      float: left;
      width: 97px;
      height: 178px;
      background-image: url(../img/tail.png);
      background-repeat: no-repeat;
    }
    .seat-body {
      height: 178px;
    }
  }
  .airplane-type-330 {
    .seat-head {
      float: left;
      width: 228px;
      height: 250px;
      background-image: url(../img/head_330.png);
      background-repeat: no-repeat;
      p {
          margin-top: 110px;
        }
    }
    .seat-tail {
      float: left;
      width: 135px;
      height: 250px;
      background-image: url(../img/tail_330.png);
      background-repeat: no-repeat;
    }
    .seat-body {
      height: 250px;
      max-width: 700px;
      padding: 5px 20px;
      overflow-x: scroll;
      overflow-y: hidden;
    }
    .seat-body-in {
      max-width: 800px;
    }
    .wing {
      left: 50%;
    }
  }

  .seat-desc {
    padding-top: 55px;
    text-align: center;
  }
  .seat-desc-list {
    width: 1100px;
    margin: 0 auto;
    li {
      display: inline-block;
      margin-right: 20px;
    }
    .seat-desc-item {
      display: inline-block;
      padding-left: 28px;
      background-position: left center;
      background-repeat: no-repeat;
      p {
        font-size: 12px;
        line-height: 18px;
        color: #808080;
      }
      p.seat-title {
        font-weight: bold;
      }
    }
    .seat-desc-item.seat1 {
      background-image: url(../img/seat1.png);
    }
    .seat-desc-item.seat2 {
      background-image: url(../img/seat2.png);
    }
    .seat-desc-item.seat3 {
      background-image: url(../img/seat3.png);
    }
    .seat-desc-item.seat4 {
      background-image: url(../img/seat4.png);
    }
    .seat-desc-item.seat5 {
      background-image: url(../img/seat5.png);
    }
    .seat-desc-item.seat6 {
      background-image: url(../img/seat6.png);
    }
    .seat-desc-item.seat7 {
      background-image: url(../img/seat6.png);
      opacity: .7;
    }
  }
  .checkin-operation {
    width: 360px;
    margin: 0 auto;
    padding-top: 60px;
    .submit-btn {
      width: 100%;
      margin-top: 10px;
    }
  }
}
@media only screen and (max-width: 768px) {
  .flight-info-components {
    width: 96%;
    border: 1px solid #bfbfbf;
    margin: 0 auto;
    overflow-x: scroll;
  }
  .checkin-step3 {
    .seat-desc-list {
      width: 98%;
      margin: 0 auto;
      li {
        float: left;
        width: 46%;
        height: 55px;
        margin: 0 2%;
      }
      .seat-desc-item {
        background-position: left top;
      }
    }
    .seat-head,
    .seat-tail {
      display: none;
    }
    .seat-bg {
      margin-top: 30px;
    }
    .seat-body {
      width: 300px;
      height: auto;
      margin: 0 auto;
      float: none;
      padding: 10px 20px;
      border-top: 0;
      border-bottom: 0;
      border-left: 1px solid #808080;
      border-right: 1px solid #808080;
    }
    .airplane-type-normal .seat-body {
      height: auto;
    }
    .airplane-type-330 .seat-body {
      width: 325px;
      padding: 10px 15px;
      height: auto;
      .seat-body-in {
        width: auto;
      }
    }
    .wing {
      display: none;
    }
  }
}
</style>
